<script lang="ts">let { size = "20" } = $props();
</script>

<svg height={size} style="fill: currentColor" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path
			d="m12.502 19.842 2.971-12.504H9.531zM10.038 2l-.85 3.904.024.103h6.574l.024-.103L14.96 2zm3.548 19 9.897-13.662h-6.647zM1.52 7.338 11.417 21 8.172 7.338zm15.625-1.331H23.5L21.033 2.3a.67.67 0 0 0-.553-.3h-4.167l.82 3.77a.5.5 0 0 1 .012.237M7.861 5.77 8.681 2H4.514a.66.66 0 0 0-.553.299L1.5 6.007h6.355a.6.6 0 0 1 .006-.237"
		/>
	</g>
</svg>
